const state = {
  isChooseDownload: false,
  files: [],
  downloadList: [],
  fileSize: 0
};

const mutations = {
  chooseDownload: (state, isChooseDownload) => {
    state.isChooseDownload = isChooseDownload;
  },
  files: (state, files) => {
    state.files = files;
  },
  downloadList: (state, list) => {
    state.downloadList = list;
  },
  fileSize: (state, size) => {
    state.fileSize = size;
  }
};

const actions = {
  addDownloadList({ commit }, obj) {
    return new Promise(resolve => {
      let downloadList = state.downloadList;
      console.log(downloadList);
      downloadList.push(obj);
      commit('downloadList', downloadList);
      resolve();
    });
  },
  reduceDownloadList({ commit }, obj) {
    return new Promise(resolve => {
      let downloadList = state.downloadList;
      downloadList = downloadList.filter(e => {
        return e.fileId !== obj.fileId;
      });
      console.log(downloadList);
      commit('downloadList', downloadList);
      resolve();
    });
  },
  addDownloadSize({ commit }, size) {
    return new Promise(resolve => {
      let fileSize = state.fileSize + size;
      console.log(fileSize);
      commit('fileSize', fileSize);
      resolve();
    });
  },
  reduceDownloadSize({ commit }, size) {
    return new Promise(resolve => {
      let fileSize = state.fileSize - size;
      commit('fileSize', fileSize);
      resolve();
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
